import React, { Component } from 'react';
import Modal from 'react-modal';
import { connectModal } from 'redux-modal';
import { AD_BLOCK_DIALOG } from '../../../constants';
import translate from '../../TranslateHOC';

class AdBlockerDialog extends Component {
  constructor() {
    super();

    this.handleCancel = this.handleCancel.bind(this);
  }

  handleCancel() {
    this.props.handleHide();
    if (this.props.handleClose) {
      this.props.handleClose();
    }
  }

  render() {
    const { show, strings } = this.props;
    const trans = strings;

    return (
      <Modal
        isOpen={show}
        overlayClassName="dialog__overlay"
        className="dialog__content"
        onRequestClose={this.handleCancel}
        role="dialog"
        ariaHideApp={true}
        contentLabel={trans.adBlockerDetected}
      >
        <div className="dialog--ad-block">
          <div className="dialog__title">{trans.adBlockerDetected}</div>
          <div className="dialog__message">
            <p>{trans.adBlockerMsg1}</p>
            <p>{trans.adBlockerMsg2}</p>
          </div>
          <div className="dialog__action-row">
            <button
              className="button-link dialog__btn dialog__btn--close-link"
              onClick={this.handleCancel}
            >
              {trans.playAnyway}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default translate(
  connectModal({ name: AD_BLOCK_DIALOG, destroyOnHide: true })(AdBlockerDialog)
);
